/**
 * assets/product.js
 * Gedrag van sections/product.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

document.addEventListener('DOMContentLoaded', () => {
  /* ─── Config from Theme Settings (via Liquid) ───*/
  /* Bezorgconfiguratie en vertalingen uit het JSON-eiland #pdp-delivery-config
     hierboven. Zie ARCHITECTURE.md sectie 11. */
  let DC = {};
  try {
    const _dcEl = document.getElementById('pdp-delivery-config');
    if (_dcEl) DC = JSON.parse(_dcEl.textContent) || {};
  } catch (_e) { DC = {}; }

  const HOLIDAYS_RAW = DC.holidays;
  const CUTOFF_RAW = DC.cutoff;
  const SAT_DELIVERY = DC.saturdayDelivery;
  const SHOW_DATE = DC.showDate;
  const SHOW_LOW_STOCK = DC.showLowStock;
  const STOCK_THRESHOLD = DC.stockThreshold;
  const BACKORDER_DEFAULT = DC.backorderDefaultDays;
  const PRODUCT_IS_RED_LABEL = (DC.productTags || []).includes('Merk_Red_Label_Aquaking');
  const PRODUCT_RESTOCK_DAYS = DC.productRestockDays;
  const PRODUCT_SUPPLIER_LEAD_DAYS = DC.productSupplierLeadDays;
  const PRODUCT_BACKORDER_DAYS = PRODUCT_IS_RED_LABEL
    ? (PRODUCT_RESTOCK_DAYS || PRODUCT_SUPPLIER_LEAD_DAYS || BACKORDER_DEFAULT)
    : (PRODUCT_SUPPLIER_LEAD_DAYS || BACKORDER_DEFAULT);
  const LOCALE = DC.locale;
  const COUNTRY = DC.country;

  /* Per-country extra delivery days*/
  const COUNTRY_EXTRA = DC.countryExtra || {};
  const COUNTRY_EXTRA_OTHER = DC.countryExtraOther;
  const EXTRA_COUNTRY_DAYS = COUNTRY_EXTRA[COUNTRY] !== undefined ? COUNTRY_EXTRA[COUNTRY] : COUNTRY_EXTRA_OTHER;

  /* Translations from locale files*/
  const T = DC.t || {};

  /* Parse holidays into Date set*/
  const holidays = new Set();
  if (HOLIDAYS_RAW) {
    HOLIDAYS_RAW.split('\n').forEach(line => {
      const d = line.trim();
      if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) holidays.add(d);
    });
  }

  /* Parse cut-off*/
  let cutoffH = 23, cutoffM = 59;
  if (CUTOFF_RAW) {
    const parts = String(CUTOFF_RAW).split('.');
    cutoffH = parseInt(parts[0]) || 23;
    cutoffM = parseInt(parts[1]) || 0;
  }

  function isHoliday(date) {
    const key = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    return holidays.has(key);
  }

  function isProcessingDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6 && !isHoliday(date);
  }

  function isDeliveryDay(date) {
    const day = date.getDay();
    if (day === 0) return false;
    if (day === 6 && !SAT_DELIVERY) return false;
    return !isHoliday(date);
  }

  function getNLDate() {
    const now = new Date();
    const f = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    });
    const p = f.formatToParts(now);
    const get = t => parseInt(p.find(x => x.type === t).value);
    return new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'));
  }

  function calculateDeliveryDate(extraDays) {
    const now = getNLDate();
    let dispatch = new Date(now);

    const isPast = (now.getHours() > cutoffH) || (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
    const isWeekend = now.getDay() === 0 || now.getDay() === 6;

    if (isPast || isWeekend || !isProcessingDay(now)) {
      dispatch.setDate(dispatch.getDate() + 1);
      while (!isProcessingDay(dispatch)) dispatch.setDate(dispatch.getDate() + 1);
    }

    let remaining = (extraDays || 0) + EXTRA_COUNTRY_DAYS;
    while (remaining > 0) {
      dispatch.setDate(dispatch.getDate() + 1);
      if (isProcessingDay(dispatch)) remaining--;
    }

    let delivery = new Date(dispatch);
    /* Always add at least 1 transit day (delivery = tomorrow minimum)*/
    delivery.setDate(delivery.getDate() + 1);
    while (!isDeliveryDay(delivery)) {
      delivery.setDate(delivery.getDate() + 1);
    }

    return delivery;
  }

  /* Map locale code to Intl locale*/
  const localeMap = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', en: 'en-GB' };
  const intlLocale = localeMap[LOCALE] || LOCALE || 'nl-NL';

  function formatDeliveryText(extraDays, isBackorder) {
    const delivery = calculateDeliveryDate(extraDays);
    const now = getNLDate();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formatted = delivery.toLocaleDateString(intlLocale, { weekday: 'long', day: 'numeric', month: 'long' });

    /* Backorder: use "verwacht in ons magazijn rond" text*/
    if (isBackorder) {
      return T.delivery_backorder.replace('__DATE__', '<strong>' + formatted + '</strong>');
    }

    if (!extraDays && EXTRA_COUNTRY_DAYS === 0 && delivery.getDate() === tomorrow.getDate() && delivery.getMonth() === tomorrow.getMonth()) {
      /* Bold everything after the comma (e.g. "Bestel nu, **vandaag verwerkt**")*/
      const parts = T.delivery_tomorrow.split(', ');
      if (parts.length > 1) return parts[0] + ', <strong>' + parts.slice(1).join(', ') + '</strong>';
      return T.delivery_tomorrow;
    }
    /* Bold the date part*/
    return T.delivery_on_date.replace('__DATE__', '<strong>' + formatted + '</strong>');
  }

  /* ─── Backorder restock label helper (JS equivalent of Liquid period calc) ───*/
  function getRestockLabel(leadtimeDays) {
    if (leadtimeDays > 45) return 'Levertijd op aanvraag'; /* klantplafond 45d (besluit 15)*/
    if (PRODUCT_IS_RED_LABEL) return 'Op bestelling, verwachte levertijd circa ' + leadtimeDays + ' dagen';
    const now = getNLDate();
    /* Approximate business-to-calendar conversion: add weekends*/
    const calDays = Math.ceil(leadtimeDays * 7 / 5);
    const target = new Date(now);
    target.setDate(target.getDate() + calDays);
    /* Bump weekends to Monday*/
    if (target.getDay() === 0) target.setDate(target.getDate() + 1);
    if (target.getDay() === 6) target.setDate(target.getDate() + 2);
    const day = target.getDate();
    const period = day <= 10 ? 'Begin' : day <= 20 ? 'Medio' : 'Eind';
    const months = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
    return period + ' ' + months[target.getMonth()] + ' weer op voorraad';
  }

  /* ─── Variant Stock Data ───*/
  const stockDataEl = document.querySelector('[data-variant-stock]');
  const stockData = stockDataEl ? JSON.parse(stockDataEl.textContent) : {};

  /* ─── Stock Countdown Timer + leverdag ───*/
  /* Bezorgbelofte (besluit Kees 16-10-2026): voor 23:59 besteld, vandaag verwerkt;
     normaal gesproken de volgende dag geleverd, bezorging van maandag t/m zaterdag.
     Nooit "vandaag verzonden" of "morgen in huis" als harde belofte.*/
  /* zo→ma, ma→di, di→wo, wo→do, do→vr, vr→za, za→ma*/
  function updateStockCountdown() {
    const el = document.querySelector('[data-vc-stock-countdown]');
    if (!el) return;
    const now = getNLDate();
    const day = now.getDay();
    const leverDagen = ['maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag','maandag'];
    const leverdag = leverDagen[day];

    /* Zondag: geen cutoff countdown, gewoon "Vandaag verwerkt, normaal gesproken maandag geleverd"*/
    if (day === 0) {
      el.innerHTML = 'Vandaag verwerkt, normaal gesproken <strong>' + leverdag + '</strong> geleverd';
      return;
    }

    /* Cutoff 23:59, bereken resterende tijd*/
    const cutoffTime = new Date(now);
    cutoffTime.setHours(23, 59, 0, 0);
    const diff = cutoffTime - now;

    if (diff <= 0) {
      el.innerHTML = 'Vandaag verwerkt, normaal gesproken <strong>' + leverdag + '</strong> geleverd';
      return;
    }

    const hours = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    el.innerHTML = 'Bestel binnen <strong>' + hours + 'u ' + String(mins).padStart(2, '0') + 'm</strong>: vandaag verwerkt, normaal gesproken <strong>' + leverdag + '</strong> geleverd';
  }
  updateStockCountdown();
  setInterval(updateStockCountdown, 60000);

  /* Detect initial variant backorder state*/
  const variantSelect = document.querySelector('[data-variant-select]');
  const initialVid = variantSelect ? variantSelect.value : null;
  const initialV = initialVid ? stockData[initialVid] : null;
  const initialBackorder = initialV && initialV.qty <= 0 && initialV.policy === 'continue' && initialV.available;
  const backorderDaysGlobal = PRODUCT_BACKORDER_DAYS || BACKORDER_DEFAULT;

  /* ─── Variant Switch Handler ───*/
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const vid = variantSelect.value;
      const v = stockData[vid];
      if (!v) return;

      const stockZone = document.querySelector('[data-stock-indicator]');
      const atcBtn = document.querySelector('[data-atc-btn]');

      const isBackorder = v.qty <= 0 && v.policy === 'continue' && v.available;
      const backorderDays = PRODUCT_BACKORDER_DAYS || BACKORDER_DEFAULT;

      /* Update stock indicator*/
      if (stockZone) {
        if (v.managed && v.qty > 0 && v.qty <= STOCK_THRESHOLD && SHOW_LOW_STOCK) {
          stockZone.className = 'flex items-center gap-2 text-sm font-bold text-koi';
          stockZone.innerHTML = '<span class="inline-block w-2.5 h-2.5 rounded-full bg-orange-500 animate-pulse shrink-0"></span> ' + T.stock_low.replace('__COUNT__', v.qty);
        } else if (v.managed && v.qty > STOCK_THRESHOLD) {
          stockZone.className = 'flex items-start gap-2';
          stockZone.innerHTML = '<span class="inline-block w-2.5 h-2.5 rounded-full bg-green-500 mt-1 shrink-0 shadow-[0_0_6px_rgba(34,197,94,0.4)]"></span><div><span class="text-sm font-bold text-green-700 block">' + T.pdp_stock_available + '</span><span class="text-xs text-green-700 font-medium block mt-0.5" data-vc-stock-countdown></span></div>';
        } else if (isBackorder) {
          stockZone.className = 'flex items-center gap-2 text-sm font-semibold text-amber-700';
          stockZone.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-amber-500 shrink-0"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> ' + getRestockLabel(backorderDays);
        } else if (!v.available) {
          stockZone.className = 'flex items-center gap-2 text-sm font-semibold text-slate-500';
          stockZone.innerHTML = T.not_in_stock;
        }
      }

      /* Update stock countdown (toon/verberg bij variant switch)*/
      const countdownEl = document.querySelector('[data-vc-stock-countdown]');
      if (countdownEl) {
        if (v.available && !isBackorder) {
          countdownEl.style.display = '';
          updateStockCountdown();
        } else {
          countdownEl.style.display = 'none';
        }
      }

      /* Update ATC button text (now targets the span inside the button)*/
      if (atcBtn) {
        const btnSpan = atcBtn.querySelector('span');
        if (btnSpan) {
          btnSpan.textContent = isBackorder && !PRODUCT_IS_RED_LABEL ? T.preorder_button : T.add_to_cart;
        }
      }

      /* Update feestdag-banner zichtbaarheid (alleen voor in-stock managed varianten)*/
      const isManagedInStock = v.managed && v.qty > 0;
      const koningsdagEl = document.querySelector('[data-koningsdag-notice]');
      if (koningsdagEl) {
        koningsdagEl.classList.toggle('hidden', !isManagedInStock);
      }
      const hemelvaartEl = document.querySelector('[data-hemelvaart-notice]');
      if (hemelvaartEl) {
        hemelvaartEl.classList.toggle('hidden', !isManagedInStock);
      }
      const pinksterenEl = document.querySelector('[data-pinksteren-notice]');
      if (pinksterenEl) {
        pinksterenEl.classList.toggle('hidden', !isManagedInStock);
      }
    });
  }
});
